import React from 'react'
import { Box, Typography } from '@mui/material'
import TextBox from '../../../common/TextBox'
import DropDownV3 from '../../../common/DropDownV3'
import { genderOptList } from '../../Booking/constant'

const EMPTY_GENDER = []

const ModifyTable = ({ seatRows = [], setFilterValue = () => { } }) => {
    const handleSeatChange = (index, field, value) => {
        setFilterValue((prev) => ({
            ...prev,
            bkgSeat: (prev.bkgSeat || []).map((row, i) => {
                if (i !== index) return row
                const updated = { ...row, [field]: value }
                return updated
            }),
        }))
        if (index === 0 && field === 'PaxName') {
            setFilterValue((prev) => ({
                ...prev,
                name: value
            }))
        }
    }
    return (
        <Box className="modifyBooking_sectionBody modifyBooking_seatSection">
            <Box className="modifyBooking_seatTable">
                <Box className="modifyBooking_seatHeader">
                    <Typography>Berth</Typography>
                    <Typography>Name</Typography>
                    <Typography>Gender</Typography>
                    <Typography>Age</Typography>
                    <Typography>Base Fare</Typography>
                </Box>
                {seatRows.map((row, index) => (
                    <Box className="modifyBooking_seatRow" key={`${row.SeatNo}-${index}`}>
                        <Typography className="modifyBooking_berth">{row.SeatNo}</Typography>
                        <Box className="smallTextBox28 modifyBooking_seatField">
                            <TextBox
                                placeholder="Name"
                                value={row.PaxName ?? ''}
                                onChange={(e) => handleSeatChange(index, 'PaxName', e.target.value)}
                            />
                        </Box>
                        <Box className="smallDropDownp28 modifyBooking_seatField modifyBooking_genderField">
                            <DropDownV3
                                width="100%"
                                name="Gender"
                                id={`modify-gender-${index}`}
                                label=""
                                options={genderOptList}
                                preSelectedValues={Array.isArray(row.Gender) ? row.Gender : EMPTY_GENDER}
                                isObject
                                primaryKey="id"
                                labelKey="label"
                                singleSelect
                                isPortal={true}
                                onSelect={(val) => handleSeatChange(index, 'Gender', val)}
                            />
                        </Box>
                        <Box className="smallTextBox28 modifyBooking_seatField modifyBooking_ageField">
                            <TextBox
                                placeholder="Age"
                                type="number"
                                value={row.Age ?? ''}
                                onChange={(e) => handleSeatChange(index, 'Age', e.target.value)}
                            />
                        </Box>
                        <Box className="smallTextBox28 modifyBooking_seatField modifyBooking_fareField">
                            <TextBox
                                placeholder="Base Fare"
                                type="number"
                                value={row.FareSTax ?? ''}
                                disabled={true}

                            />
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default ModifyTable
